/*
 * 詳細画面パーツ
 * 呼び出しコード
 */
<template>
<tr class="tr-td-control">
	<!-- 呼び出しコード -->
	<td class="td-dataname">
		<div class="layout-left"><!--
			-->{{r_title}}
		</div>
		<div class="layout-right">
			<font class="text-red" v-if="r_settings.edit_right" >＊</font>
		</div>
	</td>
	<td v-if="r_settings.edit_right" class="td-data">
		<el-form :model="m_ruleForm" :rules="m_validationCode" ref="valid_target">
			<el-form-item prop="strValue" class="text_code_area" >
				<!-- 新規 or 番号呼び出し -->
				<c-inputedit
					v-if="!r_code_disabled"
					class="text-input-code text_code"
					r_type="number"
					:r_max_length="m_maxLength"
					:r_input_class="createEditClassType(m_ruleForm.strValue)"
					:r_is_zero_fill="true"
					:r_disabled="r_disabled"
					:r_mask="r_mask"
					v-model="m_ruleForm.strValue"
					@input="onInputEdit"
					@blur="onBlurEdit"
					@keyup.enter="onBlurEdit2"
				></c-inputedit>
				<span v-if="r_code_disabled" >
					{{ r_code | addHyphen(r_mask) }}
				</span>
				<c-buttonicon v-bind:r_content=r_messages.free_numbar_btn r_class="green" :r_disabled="r_disabled" @click="onBtnFreeNumberSearch" v-if="r_settings.edit_right && is_disp_freenumsearch" >
					<span class="icon-akiban" >
						<span class="path1"></span><span class="path2"></span><span class="path3"></span><span class="path4"></span>
					</span>
				</c-buttonicon>
				<c-buttonicon v-bind:r_content=r_messages.copy_btn r_class="green" @click="onBtnCopySearch" v-if="r_settings.edit_right && is_disp_copy" :r_disabled="!m_ruleForm.strValue.length || r_disabled || r_copy_disabled" >
					<span class="icon-copymotosentaku"></span>
				</c-buttonicon>
			</el-form-item>
		</el-form >
		<!-- フッター部スロット -->
		<slot name='footer_slot'></slot>
	</td>
	<td v-else class="td-data"><!-- 空白除けコメントアウト
	-->{{ r_code | addHyphen(r_mask) }}
	</td>
</tr>
</template>
<script>
	/**
	 * 詳細画面パーツ.<br>
	 * 呼び出しコード.<br>
	 * @module js\parts\DetailItemCode
	 * @example
	 * <c-edititemcode
	 * 	:r_messages = "r_messages"
	 * 	:r_settings = "r_settings"
	 * 	:info="m_info"
	 * 	@event_close="onClose"
	 * 	@event_btn_copy="onBtnCopy"
	 * >
	 * </c-edititemcode>
	 **/

	/**
	 * props 引数
	 * @param {string[]} r_messages - 表示文言
	 * @param {string[]} r_settings - 初期設定値
	 * @param {object} info - 編集するデータ
	 * @param {bool} r_disp = {btn_copy:true,btn_freenumsearch:true} - ボタンを表示するか、しないか
	 **/
	 export default {
		props:{
			'r_title':{
				type:String,
				default:""
			},
			'r_code':{
				default:""
			},
			'r_messages':{},
			'r_settings':{},
			'r_disp':{},
			'r_disabled':{
				default: false
			},
			'r_copy_disabled':{
				default:false
			},
			'r_code_disabled':{
				default:false
			},
			'r_code_max':{
				type:[Number,String],
				default:999999
			},
			'r_code_min':{
				type:[Number,String],
				default:1
			},
			'r_validator':null,//!< validate 処理を変更したい場合に指定する。指定がなければデフォルトチェックが有効になる
			'r_mask':null,//! ハイフン対応（inputEditMask）用
		},
		mixins: [
			require('js/common/Edit.mixin.vue'),
			require('js/common/trEdit.mixin.vue'),
			// バリデーションミックスイン
			require('js/common/validate/common.mixin.vue'),
			require('js/common/validate/edit.mixin.vue'),
		],
		data:function (){
			var target = this;
			return{
				m_ruleForm:{ strValue:"" },
				m_maxLength:6,
				m_validationCode:  {
					strValue: [
						{
							validator: (rule, value, callback) => {
								// チップバリデーションを非表示にするためコメントアウト
								// var fnValidate = (target.r_validator)?target.r_validator:target.validateType;

								// var errMessage = fnValidate([target.CHKTYPE_CODE,target.CHKTYPE_NULL],
								// 										value,
								// 										target.r_code_max,
								// 										target.r_code_min);
								// if ( errMessage.length > 0 ) {
								// 	callback(new Error(errMessage));
								// } else {
								// 	callback();
								// }
							},
							trigger: ''
						}
					],
				},
				m_isValidatMessageReset: true,
				m_isChange_enter: false,
			};
		},
		created: function() {
			this.m_ruleForm.strValue = this.r_code;
			if (this.r_code_max && this.r_code_max.toString().length > 0) {
				this.m_maxLength = this.r_code_max.toString().length;
			}
		},
		/**
		 * @instance
		 **/
		computed: {
			//! ボタン表示判定
			is_disp_freenumsearch: function(){
				if(this.r_disp && this.r_disp.btn_freenumsearch != undefined){
					return this.r_disp.btn_freenumsearch;
				}
				return true;
			},
			//! ボタン表示判定
			is_disp_copy: function(){
				if(this.r_disp && this.r_disp.btn_copy != undefined){
					return this.r_disp.btn_copy;
				}
				return true;
			},
		},
		watch: {
			r_code_max: function(val){
				if (this.r_code_max && this.r_code_max.toString().length > 0) {
					this.m_maxLength = this.r_code_max.toString().length;
				}
			},
			r_code: function(val){
				this.m_ruleForm.strValue = this.format(val);
				console.log("format : val ->" + this.m_ruleForm.strValue);
			},
		},
		methods: {
			format : function(val){
				var maxLen = this.m_maxLength;
				var temp = val + "";
				if(Number(temp) == 0){
//					temp = "";
				}else if(temp.length > 0)
				{
					while(temp.length < maxLen){
						temp = "0" + temp;
					}
				}
				return temp;
			},
			/**
			 * エディター入力時に呼ばれる <br>
			 * ******* 内部処理 *******<br>
			 *
			 * @function  onInputEdit
			 * @instance
			 */
			onInputEdit: function(){
				if( Number(this.m_ruleForm.strValue) != Number(this.r_code) ||
					( this.m_ruleForm.strValue == "" && this.r_code != "" ) ||
					( this.m_ruleForm.strValue != "" && this.r_code == "" )
				){
					// 値の変更判定
					this.m_isChange = true;
				}
			},
			/**
			 * 呼出番号からフォーカスアウト <br>
			 * ******* 内部処理 *******<br>
			 * フォーカスインから呼び出しコードが変更されていた場合、<br>
			 * DBから呼び出しコードに対応したデータを取得する。 <br>
			 * 対応したデータが存在しない場合は新規として表示する。 <br>
			 *
			 * @function  onBlurEdit
			 * @instance
			 */
			onBlurEdit: function(){
				if(!this.m_isChange_enter){
					this.$emit("input",this.m_ruleForm.strValue);
					if( Number(this.m_ruleForm.strValue) != Number(this.r_code) ||
						( this.m_ruleForm.strValue == "" && this.r_code != "" ) ||
						( this.m_ruleForm.strValue != "" && this.r_code == "" )
					){
						// 値の変更判定
						this.m_isChange = true;
						this.$emit("event_change",this.m_ruleForm.strValue);
					}
				}else{
					this.m_isChange_enter = false;
				}
			},
			/**
			 * 呼出番号からフォーカスアウト <br>
			 * ******* 内部処理 *******<br>
			 * フォーカスインから呼び出しコードが変更されていた場合、<br>
			 * DBから呼び出しコードに対応したデータを取得する。 <br>
			 * 対応したデータが存在しない場合は新規として表示する。 <br>
			 *
			 * @function  onBlurEdit2
			 * @instance
			 */
			onBlurEdit2: function(){
				this.$emit("input",this.m_ruleForm.strValue);
				if( Number(this.m_ruleForm.strValue) != Number(this.r_code) ||
					( this.m_ruleForm.strValue == "" && this.r_code != "" ) ||
					( this.m_ruleForm.strValue != "" && this.r_code == "" )
				){
					// 値の変更判定
					this.m_isChange = true;
					this.m_isChange_enter = true;
					this.$emit("event_change",this.m_ruleForm.strValue);
				}
			},
			/**
			 * コピー元データ取得イベント <br>
			 * ******* 内部処理 *******<br>
			 * event_btn_copyでイベントを受け取り、親にevent_btn_copyイベントを投げる。 <br>
			 *
			 * @function  event_btn_copy
			 * @param {object} info - 元データ
			 * @param {object} copyInfo - コピー元データ
			 * @instance
			 */
			onBtnCopySearch: function(){
				this.$emit("event_btn_copysearch");
			},
			/**
 			 * 空き番号検索ボタン
			 */
			onBtnFreeNumberSearch: function(){
				this.$emit("event_btn_freenumsearch",this.m_ruleForm.strValue);
			},
			/**
			 * クローズイベント <br>
			 * ******* 内部処理 *******<br>
			 * event_closeでイベントを受け取り、親にevent_closeイベントを飛ばす。 <br>
			 *
			 * @function  event_close
			 * @param {bool} is - クローズフラグ
			 * @instance
			 */
			onClose: function( is ){
				this.$emit('event_close', is);
			},
		},
		filters: {
			addHyphen: function (value, r_mask) {
				if (!value) return '';
				if( r_mask ) {
					let temp = value;
					return temp.slice(0,4) + "-" + temp.slice(4);
				}
				return value;
			}
		},
	}
</script>



// WEBPACK FOOTER //
// resources/assets/js/parts_com/TR/editCode.vue